import { NumberFormatOptionsSignDisplay } from "@formatjs/ecma402-abstract";

export class Currency {
  code: string;
  name: string;

  constructor(code: string, name: string) {
    this.code = code;
    this.name = name;
  }
}

export class Amount {
  amount?: number;
  currency?: string;
  signDisplay?: NumberFormatOptionsSignDisplay;

  constructor(currency?: string, amount?: number, signDisplay?: NumberFormatOptionsSignDisplay) {
    this.amount = amount;
    this.currency = currency;
    this.signDisplay = signDisplay;
  }
}

export type NumberFormatOptionsCurrencyDisplay = "symbol" | "code" | "name" | "narrowSymbol";
